export const InactiveGoalException = 'InactiveGoalException';
